import theme from '@mote/ui/theme'

export const REACTION_EMOJIS = [
  {
    id: 0,
    emoji: '👍',
    value: 'thumbsUp',
    label: 'Like',
    description: 'Thumbs up!',
    accentColor: theme.colors.orange.d2
  },
  {
    id: 1,
    emoji: '🤔',
    value: 'thinking',
    label: 'Thinking',
    description: 'May need some time!',
    accentColor: theme.colors.orange.d2
  },
  {
    id: 2,
    emoji: '🤣',
    value: 'laugh',
    label: 'Laugh',
    description: 'This is funny!',
    accentColor: theme.colors.orange.d2
  },
  {
    id: 3,
    emoji: '💜',
    value: 'heart',
    label: 'Love',
    description: 'Love this!',
    accentColor: theme.colors.primary.base
  }
] as const

export type Reaction = typeof REACTION_EMOJIS[number]
